  <div class="sheet-block-title"><span translate>sheet-view.exercices</span></div>
  <div *ngIf="sheet">
    <div class="sheet-helpcopy">
      <span translate>sheet-view.help</span>
    </div>
    <div class="difficulty-blocks-wrap">
      <div class="difficulty-block difficulty-easy" (click)="goToExercice('easy')"><div class="difficulty-icon" ></div><span class="difficulty-label" translate>exercices.easy</span><br/></div>
      <div class="difficulty-block difficulty-medium" (click)="goToExercice('medium')"><div class="difficulty-icon" ></div><span class="difficulty-label" translate>exercices.medium</span><br/></div>
     <div class="difficulty-block difficulty-hard" (click)="goToExercice('hard')"><div class="difficulty-icon" ></div><span class="difficulty-label" translate>exercices.challenge</span><br/></div>
    </div>
  </div>